import { Platform } from 'react-native';

const APP_URL_FALLBACK = 'https://dramadetector.com';

const ENV_APP_URL = (
  process.env.EXPO_PUBLIC_APP_URL || APP_URL_FALLBACK
).replace(/\/+$/, '');

/**
 * Returns the app base URL, preferring the browser origin on web
 * and falling back to the EXPO_PUBLIC_APP_URL env var.
 */
export function getAppUrl(): string {
  if (
    Platform.OS === 'web' &&
    typeof window !== 'undefined' &&
    window.location
  ) {
    return window.location.origin;
  }
  return ENV_APP_URL;
}

/**
 * Build a full referral URL from a referral code.
 */
export function buildReferralUrl(code: string): string {
  return `${getAppUrl()}/ref/${code}`;
}
